import $ from 'jquery';
import 'jquery-ui';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui-timepicker-addon';

import AOS from 'aos';
import 'aos/dist/aos.css';

import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PerfectScrollbar from 'perfect-scrollbar';

import * as helper from "./helper";

AOS.init({
    duration: 1000,
    easing: 'slide'
});

const axios = require('axios').default;
const validate = require( "jquery-validation" );

const originUrl = window.location.origin;
let footerHeight = $("footer").height();
let isFetching = false;
let page = 1;
let card = 8;
let countAllMovies;
// let lastLoadedPage = 0;

let offset;
let isOriginLeft;
if (document.querySelector("html").getAttribute("lang") == "en"){
    offset = 30;
    isOriginLeft = true;
} else {
    offset = 40;
    isOriginLeft = false;
}

const shareOnFacebook = (e) => {
    e.preventDefault();
    window.open(
      "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href,
      "Facebook-dialog",
      "width=626,height=436"
    );
};

const shareOnTwitter = (e) => {
    e.preventDefault();
    let docTitle = document.title;
    let titlesArr = docTitle.split(" - ");
    let title = titlesArr[titlesArr.length - 1];
    var element = document.createElement("div");
    element.innerText = title;
    var sanitizedHTML = element.innerHTML;
    window.open(
      "https://twitter.com/intent/tweet?text=" +
        sanitizedHTML +
        "&url=" +
        window.location.href,
      "Twitter-dialog",
      "width=626,height=436"
    );
};

// Share Current On Facebook
$(document).on("click", ".facebookShare", (event) => {
    event.preventDefault();
    shareOnFacebook(event);
});

// Share Current On Twitter
$(document).on("click", ".twitterShare", (event) => {
    event.preventDefault();
    shareOnTwitter(event);
});

// Open Menu Trigger
$(document).on("click", "#toggleMenu", function (event) {

    event.preventDefault();
    $("html").css("overflow", "hidden");
    $("#navbar").addClass("show-nav");


});
$(document).on("click", "#closeMenu", function (event) {

    event.preventDefault();
    $("html").css("overflow", "auto");
    $("#navbar").removeClass("show-nav");

});

// Footer Check Checkbox Blue Sign
const checkNewsletterCheckbox = () => {
    document.querySelectorAll("footer .checkbox input").forEach(function(element){
        element.addEventListener("click", () => {
            element.parentNode.classList.toggle("checked");
        });
    });
}
checkNewsletterCheckbox();

// Header Searchbar Actions
if ($("#openSearchbar").length > 0) {
    document.querySelector("#openSearchbar").addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector("#searchbar").classList.add("open");
        document.querySelector("main").classList.add("show-searchbar");
    });
}
if ($("#closeSearchbar").length > 0) {
    document.querySelector("#closeSearchbar").addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector("#searchbar").classList.remove("open");
        document.querySelector("main").classList.remove("show-searchbar");
        document.querySelector("#header-search").value = "";
    });
}

const clickSearchHeader = () => {
    if ($("#searchHeaderButton").length > 0) {
        document.querySelector("#searchHeaderButton").addEventListener("click", (event) => {
            event.preventDefault();
            let searchVal = document.querySelector('#header-search').value;
            window.location.href = document.querySelector("#searchResultsUrl").value + '?search=' + searchVal;
        });
    }
    if ($("#header-search").length > 0) {
        document.querySelector("#header-search").addEventListener('keydown', (event) => {
            let searchVal = document.querySelector('#header-search').value;
            if (event.keyCode === 13) {
                window.location.href = document.querySelector("#searchResultsUrl").value + '?search=' + searchVal;
            }
        });
    }
}
clickSearchHeader();

const submitFct = async ( form, action ) => {
    let formData = new FormData(form);
    try {
        const response = await axios.post(action, formData);
        const result = await response.data;
        document.querySelector("#resultsCount").innerHTML = result.count;
        document.querySelector("#resultsListing").innerHTML = result.results;
    } catch (error) {
        console.log(error);
    }
}

// Search Results Page Form Actions
const searchFormSubmit = () => {
    let form = document.querySelector('#getSearchResultsForm');
    let action = form.getAttribute("action");
    form.addEventListener("submit", (event) => {
        event.preventDefault();
        var VAR_CAPTCHA_ACTIVATE = $("#VAR_CAPTCHA_ACTIVATE").val();
        if (VAR_CAPTCHA_ACTIVATE == 1) {
            var VAR_CAPTCHA_SITE_KEY = $("#VAR_CAPTCHA_SITE_KEY").val();
            try {
                grecaptcha.execute(VAR_CAPTCHA_SITE_KEY, {
                    action: "search"
                }).then(function(tokenCaptcha) {
                    $("#g-recaptcha-response-search").val(tokenCaptcha);
                    if (tokenCaptcha == "") {
                        button.val(buttonSection).attr("disabled", false);
                        alert(trans("main.verify_that_not_robot"));
                        return false;
                    } else {
                        submitFct(form, action);
                    }
                }, function(reason) {
                    alert(trans("main.verify_that_not_robot"));
                    return false;
                });
            } catch (error) {
                console.log(error);
                submitFct(form, action);
            }
        } else {
            submitFct(form, action);
        }
    });

};


const searchFormReset = () => {
    let form = document.querySelector('#getSearchResultsForm');
    let action = form.getAttribute("action");
    let resetButton = document.querySelector("#resetSearchForm");
    resetButton.addEventListener("click", (event) => {
        event.preventDefault();
        document.querySelector('#resultsSearchInput').value = '';
        resetButton.style.display = "none";
        // submitFct(form,action);
    });
};
if ($("body.results-page").length > 0) {
    const inputSearch = document.querySelector('#resultsSearchInput');

    inputSearch.addEventListener('input', updateValue);

    function updateValue (e) {
        e.preventDefault();
        document.querySelector("#resetSearchForm").style.display = "inline-block";
    }
    searchFormReset();
    searchFormSubmit();
}

// Get Movies + Filter Fucntion
const getMovies = (page, append = true) => {

    if (isFetching) return;  // Exit if a request is already in progress

    isFetching = true;  // Set the flag to indicate a request is in progress

    document.querySelector(".no-movies-title").style.display = "none";
    $(".movies-auto-load").css("display", "flex");
    let year = $("#productionYear").val();
    let territory = $("#productionTerritory").val();
    let type = $("#productionType").val();
    let url = $("#viewMoviesByFilterBtn").data("url");

    axios.get(url + '?card=' + card + "&page=" + page + "&year=" + year + "&territory=" + territory + "&type=" + type)
        .then(response => {
            // console.log(response.data);
            if (response.status == 200) {
                if (append == true) {
                    $(".movies-listing-inner").append(response.data.movies);
                } else {
                    $(".movies-listing-inner").html(response.data.movies);
                }
                countAllMovies = response.data.countAllMovies;
                if (countAllMovies == 0) {
                    document.querySelector(".no-movies-title").style.display = "flex";
                    $(".movies-auto-load").css("display", "none");
                }
                setTimeout(() => {
                    $(".movies-auto-load").css("display", "none");
                }, 200);
                // lastLoadedPage = page;
                // return lastLoadedPage;
            }

        })
        .catch(err => {
            // Handle Error Here
            console.error(err);
        })
        .finally(() => {
            isFetching = false;  // Reset the flag after the request completes
        });
}

// Open Question FAQ's
$(".single-question .question-header").on("click", function(event){

    event.preventDefault();

    $(this).parent().toggleClass("show");

    let box = $(this).parent().find(".answer");
    let minimumHeight = 0;

    // get current height
    let currentHeight = box.height();

    // get height with auto applied
    let autoHeight = box.css('height', 'auto').height();

    // reset height and revert to original if current and auto are equal
    box.css('height', currentHeight).animate({
        height: (currentHeight == autoHeight ? minimumHeight : autoHeight)
    }, 300);

    if(currentHeight != autoHeight){
        setTimeout(function(){
            box.css('height', 'auto');
        }, 400);
    }
});

$("#subscribe-button").on("click", function(e){

    e.preventDefault();

    $("#subscribeNameError, #subscribeEmailError").css("display", "none");

    let isEmpty = false;
    let form = $("#subscribeForm");
    let nameValue = form.find("input[name='name']").val();
    let emailValue = form.find("input[name='email']").val();

    if(nameValue == ""){
        $("#subscribeNameError").css("display", "inline-block");
        isEmpty == true;
    }
    if(emailValue == ""){
        $("#subscribeEmailError").css("display", "inline-block");
        isEmpty == true;
    }
    if(isEmpty){
        return;
    }
})

$("#newApply-button").on("click", function(e){

    e.preventDefault();

    $("#apply1Error").css("display", "none");


    let form = $("#newApplyForm");
    console.log(form);
    var checkboxes =  document.querySelectorAll("input[type='checkbox']:checked");

    // Initialize a counter for checked checkboxes
    var checkedCount = 0;

    // Loop through each checkbox
    checkboxes.forEach(function(checkbox) {
        // If checkbox is checked, increment the counter
        if (checkbox.checked) {
            checkedCount++;
        }
    });

    // Perform validation
    if (checkedCount < 2) {
        // Less than 2 checkboxes are checked, show an error message
        $("#apply1Error").css("display", "inline-block");
        // Return false to prevent form submission
        return false;
    }
     // Otherwise, return true to allow form submission
     form.submit();
     return true;
})
// Share Button Expand Icons
$("#mediaShareButton").on("mouseover", function(){
    $(this).toggleClass("expanded");
})
$("#mediaShareButton").on("click", function(){
    $(this).toggleClass("expanded");
})

$("#mediaShareButton").on("mouseout", function(){
    $(this).toggleClass("expanded");
})



$(document).on("click",".homepage .section-one .play-video, #mediaDetailsPagePlayVideoTrigger, #locationsListingVideoTrigger, #infrastructureVideoTrigger, #studioVideoTrigger, #filmingIntroVideoTrigger, #cashbackExpressVideoTrigger", function (event) {
    event.preventDefault;
    var video_platform = $(this).data("video_platform");
    var video_key = $(this).data("video_key");
    let iframeSrc = "";
    if ((video_platform != "None") && (video_key != "")) {
        if (video_platform == "Youtube") {
            iframeSrc = "https://www.youtube.com/embed/" + video_key + "?autoplay=1";
        } else if (video_platform == "Vimeo") {
            iframeSrc = "https://player.vimeo.com/video/" + video_key + "?title=0&byline=0&portrait=0";
        }
    }
    $(".videoPopup iframe").attr("src", iframeSrc);
    $("html").css("overflow-y", "hidden");
    $(".videoPopup").fadeIn("slow").css("display", "flex");
});

$(document).on("click", ".homepage .videoPopup .closeBtn, .media-listing-page .videoPopup .closeBtn, .locations-page .videoPopup .closeBtn, .infrastructure-page .videoPopup .closeBtn, .filming-page .videoPopup .closeBtn, .cashback-rebate .videoPopup .closeBtn", function (event) {
    event.preventDefault();
    $(".videoPopup").fadeOut("slow");
    $("html").css("overflow-y", "auto");
    $(".videoPopup iframe").attr("src", " ");
});
$(document).on("click", ".openSectionPopup", function (event) {
    event.preventDefault();
    $(".section-popup").find("#feature1").text($(this).data("feature1"));
    $(".section-popup").find("#feature2").text($(this).data("feature2"));
    $(".section-popup").find("#feature3").text($(this).data("feature3"));
    $(".section-popup").find("#feature4").text($(this).data("feature4"));
    $(".section-popup").find("#feature5").text($(this).data("feature5"));
    $(".section-popup #sectionTitle").html($(this).closest(".inner-container").find(".title span").html());
    $(".section-popup #sectionDescription").html($(this).closest(".inner-container").find(".description p").html());
    $(".section-popup #sectionImg").attr("src",($(this).closest(".inner-container").find(".image img").attr("src")));
    $("html").css("overflow-y", "hidden");
    $("#sectionPopup").fadeIn("slow").css("display", "flex");
});

$(document).on("click", ".filming-page .section-popup .close-container", function (event) {
    event.preventDefault();
    $("#sectionPopup").fadeOut("slow");
    $("html").css("overflow-y", "auto");
});

$("#contactUsForm").validate({
    rules: {
        first_name: {
            required: true,
        },
        last_name: {
            required: true,
        },
        email: {
            required: true,
            minlength: 3,
        },
        subject: {
            required: true,
        },
        message: {
            required: true,
            minlength: 3,
        },
    },
    messages: {
        // title: {
        //     required: "Please select a title",
        // },
        subject: {
            required: "Please select a subject",
        },
        first_name: {
            required: "Please write your first name",
            minlength: "Name should be at least 3 characters",
        },
        last_name: {
            required: "Please write your last name",
            minlength: "Name should be at least 3 characters",
        },
        email: {
            required: "Please write your email address",
            email: "Please write a valid email address"
        },
        message: {
            required: "Please write your message",
        },
    },
    errorPlacement: function(error, element) {
        error.insertAfter(element);
    },
});
$("#submitContactForm").on("click", function(e){
    e.preventDefault();
    let form = $("#contactUsForm");
    $('label.captcha-error').html('');
    if (form.valid()) {
        $("#formValidationError").css("display", "none");
        let VAR_CAPTCHA_ACTIVATE = $("#VAR_CAPTCHA_ACTIVATE").val();
        if (VAR_CAPTCHA_ACTIVATE == 1) {
            let VAR_CAPTCHA_SITE_KEY = $("#VAR_CAPTCHA_SITE_KEY").val();
            try {
                grecaptcha.execute(VAR_CAPTCHA_SITE_KEY, {
                    action: "contactus"
                }).then(function(tokenCaptcha) {
                    $("#g-recaptcha-response").val(tokenCaptcha);
                    if (tokenCaptcha == "") {
                        $('label.captcha-error').html('Please verify that you are not a robot');
                        return false;
                    } else {
                        form.submit();
                        form[0].reset();
                    }
                }, function(reason) {
                    $('label.captcha-error').html('Please verify that you are not a robot');
                    return false;
                });
            } catch (error) {
                console.log(error);
                form.submit();
                form[0].reset();
            }
        } else {
            form.submit();
            form[0].reset();
        }
    } else {
        $("#formValidationError").css("display", "block");
        return false;
    }
});

$("#rebateGuidelinesForm").validate({
    rules: {
        first_name: {
            required: true,
        },
        last_name: {
            required: true,
        },
        company_name: {
            required: true,
        },
        position: {
            required: true,
        },
        email: {
            required: true,
            minlength: 3,
        },
        contact_number: {
            required: true,
            number: true,
        },
    },
    messages: {
        first_name: {
            required: "Please write your first name",
            minlength: "Name should be at least 3 characters",
        },
        last_name: {
            required: "Please write your last name",
            minlength: "Name should be at least 3 characters",
        },
        company_name: {
            required: "Please enter the company",
        },
        position: {
            required: "Please enter the position",
        },
        email: {
            required: "Please write your email address",
            email: "Please write a valid email address"
        },
        contact_number: {
            required: "Please enter the Telephone",
            number: "Please enter a valid number",
        },
    },
    errorPlacement: function(error, element) {
        error.insertAfter(element);
    },
});
$("#submitRebateGuidelinesForm").on("click", function(e){
    e.preventDefault();
    let form = $("#rebateGuidelinesForm");
    $('label.captcha-error').html('');
    if (form.valid()) {
        $("#formValidationError").css("display", "none");
        let VAR_CAPTCHA_ACTIVATE = $("#VAR_CAPTCHA_ACTIVATE").val();
        if (VAR_CAPTCHA_ACTIVATE == 1) {
            let VAR_CAPTCHA_SITE_KEY = $("#VAR_CAPTCHA_SITE_KEY").val();
            try {
                grecaptcha.execute(VAR_CAPTCHA_SITE_KEY, {
                    action: "RebateGuidelines"
                }).then(function(tokenCaptcha) {
                    $("#g-recaptcha-response").val(tokenCaptcha);
                    if (tokenCaptcha == "") {
                        $('label.captcha-error').html('Please verify that you are not a robot');
                        return false;
                    } else {
                        form.submit();
                        form[0].reset();
                    }
                }, function(reason) {
                    $('label.captcha-error').html('Please verify that you are not a robot');
                    return false;
                });
            } catch (error) {
                console.log(error);
                form.submit();
                form[0].reset();
            }
        } else {
            form.submit();
            form[0].reset();
        }
    } else {
        $("#formValidationError").css("display", "block");
        return false;
    }
});

// FAQs Menu Item Click Event
if($(".faq-page").length){
    $(".faq-page .section-one .left a").on("click", function(e) {
        e.preventDefault();
        $(".faq-page .section-one .left a").removeClass("active");
        $(this).addClass("active");
        let sectionId = $(this).attr("href");
        $('html,body').animate({
            scrollTop: $(sectionId).offset().top - 90},
            600);
    });

    // Get all sections that have an ID defined
    const sections = document.querySelectorAll(".faq-page .faqs-container");
    const navLi = document.querySelectorAll(".faq-page .section-one .left a");

}

// Filmed in AUH Pages: Dropdown Open Action
for (const dropdown of document.querySelectorAll(".filmed-main-section .dropdown-title")){
    dropdown.addEventListener("click", function (event) {
        event.preventDefault();
        this.parentNode.classList.toggle("open");
    });
}
for (const option of document.querySelectorAll(".filmed-main-section li")) {
    option.addEventListener("click", function (event) {
        event.preventDefault();
        if (!this.classList.contains("selected")) {
            this.parentNode.querySelector(".filmed-main-section li.selected").classList.remove("selected");
            this.classList.add("selected");
            this.closest(".filmed-main-section .dropdown-item").querySelector(".filmed-main-section .dropdown-title span").textContent = this.textContent;
            if(this == this.parentNode.firstElementChild){
                this.closest(".filmed-main-section .dropdown-item").querySelector(".filmed-main-section .dropdown-title input").value = "";
            }
            else {
                this.closest(".filmed-main-section .dropdown-item").querySelector(".filmed-main-section .dropdown-title input").value = this.textContent;
            }
            this.closest(".filmed-main-section .dropdown-item").classList.toggle("open");
        }
    });
}
const closeDropdownOnWindowClick = () => {
    window.addEventListener("click", function (e) {
        for (const select of document.querySelectorAll(".filmed-main-section .dropdown-item")) {
            if (!select.contains(e.target)) {
                select.classList.remove("open");
            }
        }
    });
}

$("#resetMoviesFilterBtn").on("click", function(event){

    event.preventDefault();
    page = 1;
    for(const title of document.querySelectorAll(".dropdown-title")){
        title.parentNode.querySelector("span").textContent = title.parentNode.querySelector(".first-option").textContent;
        title.parentNode.querySelector(".selected").classList.remove("selected");
        title.parentNode.querySelector(".first-option").classList.add("selected");
    }

    $("#productionYear, #productionType, #productionTerritory").val("");

    let filter = document.querySelector("#filterMoviesForm")
    filter.classList.contains("open") ? filter.classList.remove("open") : "";
    if (!isFetching){
        getMovies(page, false);
    }

});

// Open Filter Section Inside Filmed Page
$("#openFilterTrigger").on("click", function(event){

    event.preventDefault();

    $(this).parent().find("form").toggleClass("open");
});

// Filter Movies Submit
$("#viewMoviesByFilterBtn").on("click", function(event){

    event.preventDefault();
    page = 1;

    let filter = document.querySelector("#filterMoviesForm")
    filter.classList.contains("open") ? filter.classList.remove("open") : "";

    getMovies(page, false);

});



const onScrollGetMovies = () => {
    $(window).on("scroll", function() {
        if (!isFetching && $(window).scrollTop() >= ($(document).height() - footerHeight - $(window).height() + 80)) {
            page++;
            if ((page * card) <= countAllMovies + (card - (countAllMovies % card) )) {
                // if (page != (getMovies(page, true) + 1)) {
                //     return false;
                // }
                getMovies(page, true);
            }
        }
    });
}

// Media Listing Page Load More Feature
let mediasCountAll = 0;
let mediasCountFetched = 0;
let mediasPage = 1;
let perPage = 6;
let currentLang = $("html").attr("lang");
const getMedias = () => {
    let cards = "";
    const category = $("#mediaTabs .tab.active").data("section");
    var url = `${originUrl}/get-medias/${category}/${mediasPage}/${perPage}/${currentLang}`
    if (currentLang != 'en') {
        url = `${originUrl}/${currentLang}/get-medias/${category}/${mediasPage}/${perPage}/${currentLang}`
    }
    axios.get(url)
    .then(response => {
        const medias = response.data.medias;
        if (medias.length > 0) {
            // let iconPath = "";
            const listingContainer = $('#mediaCardsListing');
            medias.forEach(media => {
                // if (media.type == "article") {
                //     iconPath = $("#newsIcon").val();
                // } else if(media.type == "video") {
                //     iconPath = $("#videoIcon").val();
                // } else {
                //     iconPath = $("#photoIcon").val();
                // }
                cards += `
                <div class="card  aos-init aos-animate"
                    data-aos="fade-up" data-section="${media.type}">
                    <div>
                        <div class="image-container">
                            <img loading="lazy" src="${media.image}" alt="Abu Dhabi Film Commission" >
                        </div>
                        <div><h4 class="title"><a href="${media.slug}">${media.title}</a></h4></div>
                        <div class="details">${media.description}</div>
                    </div>
                </div>
                `;
            });

            listingContainer.append(cards);

            mediasCountAll = response.data.countAll;
            if(mediasCountAll == 0){
                $(".no-listing-title").css("display", "flex");
                $(".auto-load").css("display", "none");
            }
            setTimeout( () => {
                $(".auto-load").css("display", "none");
            }, 200);

            mediasCountFetched += response.data.countFetched;
            mediasPage++;

            window.addEventListener('scroll', onScrollGetMedias);
        }
    })
    .catch(error => {
        console.error('Error fetching listing data:', error);
    });
}

const onScrollGetMedias = () => {
    if($(window).scrollTop() >= ($(document).height() - footerHeight) - $(window).height() + 80){
        if (mediasCountFetched < mediasCountAll) {
            $(".auto-load").css("display", "flex");
            window.removeEventListener('scroll', onScrollGetMedias);
            getMedias();
        } else {
            $(".auto-load").css("display", "none");
        }
    }
}

$(document).ready(function() {
    let url = document.location.pathname;
    if($("#mediaTabs").length){
        if(url.indexOf('/media-centre/articles') > -1){
            $("#MediaArticles").addClass("active");
        }
        else if(url.indexOf('/media-centre/photos') > -1){
            $("#MediaPhotos").addClass("active");
        }
        else if(url.indexOf('/media-centre/videos') > -1){
            $("#MediaVideos").addClass("active");
            $('#mediaTabs .inner-container').animate({scrollLeft:$('#MediaVideos').offset().left});
        }
        else {
            $("#AllMedia").addClass("active");
        }
        getMedias();
        window.addEventListener('scroll', onScrollGetMedias);
    }
    if($("#cashbackTabs").length){
        if(url.indexOf('/35-rebate/faqs') > -1){
            $("#cashbackFaq").addClass("active");
            $('#cashbackTabs .inner-container').animate({scrollLeft:$('#cashbackFaq').offset().left});
            $(window).width() < 768 ? "" : $(".body-container").css("overflow", "visible");
        }
        else if(url.indexOf('/35-rebate/35-cashback-express-tvc-rebate') > -1){
            $("#cashbackExpress").addClass("active");
            $('#cashbackTabs .inner-container').animate({scrollLeft:$('#cashbackExpress').offset().left - 30});
        }
        else if(url.indexOf('/interim-disclaimer') > -1){
            $(".tab.apply-button").addClass("active");
        }
        else {
            $("#cashbackIntroduction").addClass("active");
        }
    }
    if($("#filmingTabs").length){
        if(url.indexOf('/filming-in-abu-dhabi/faqs') > -1){
            $("#filmingFaq").addClass("active");
            $('#filmingTabs .inner-container').animate({scrollLeft:$('#filmingFaq').offset().left - 30});
            $(window).width() < 768 ? "" : $(".body-container").css("overflow", "visible");
        }
        else if(url.indexOf('/filming-in-abu-dhabi/infrastructure') > -1){
            $("#filmingInfrastructure").addClass("active");
            $('#filmingTabs .inner-container').animate({scrollLeft:$('#filmingInfrastructure').offset().left - 30});
            $(window).width() < 768 ? "" : $(".body-container").css("overflow", "visible");
        }
        else if(url.indexOf('/filming-in-abu-dhabi/covid') > -1){
            $("#filmingCovid").addClass("active");
            $('#filmingTabs .inner-container').animate({scrollLeft:$('#filmingCovid').offset().left - 30});
        }
        else if(url.indexOf('/filming-in-abu-dhabi/filmed-in-abu-dhabi') > -1){
            $("#filmingFilmed").addClass("active");
            $('#filmingTabs .inner-container').animate({scrollLeft:$('#filmingFilmed').offset().left - 30});
        }
        else if(url.indexOf('/filming-in-abu-dhabi/permits') > -1){
            $("#filmingPermits").addClass("active");
            $('#filmingTabs .inner-container').animate({scrollLeft:$('#filmingPermits').offset().left - 30});
        }
        else {
            $("#filmingIntroduction").addClass("active");
        }
    }
    if($("#aboutTabs").length){
        if(url.indexOf('/about-abu-dhabi/what-is-on-in-abu-dhabi') > -1){
            $("#aboutWhatsOn").addClass("active");
            $('#aboutTabs .inner-container').animate({scrollLeft:$('#aboutWhatsOn').offset().left});
        }
        else if(url.indexOf('/about-abu-dhabi/filmed') > -1){
            $("#aboutFilming").addClass("active");
            $('#aboutTabs .inner-container').animate({scrollLeft:$('#aboutFilming').offset().left - 30});
        }
        else {
            $("#aboutIntroduction").addClass("active");
        }
    }
    if ($(".movies-listing-inner").length) {
        if (!isFetching){
            closeDropdownOnWindowClick();
            getMovies(page, true);
            onScrollGetMovies();
        }
    }
    $("#homepageFirstSlider").slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        fade: true,
        cssEase: 'linear',
        pauseOnHover: false,
        rtl: $("body").hasClass("rtl") ? true : false,
    });

    if ($(window).width() < 768) {
        $(".homepageLocationsSlider").slick({
            // centerMode: true,
            centerPadding: '75px',
            slidesToShow: 1.7,
            dots: false,
            arrows: false,
            rtl: $("body").hasClass("rtl") ? true : false,
            responsive: [
                {
                    breakpoint: 586,
                    settings: {
                        slidesToShow: 1.1,
                        centerMode: false,
                        centerPadding: 0,
                        infinite: false
                    }
                }
            ]
        });
        $("#instagramSlider").slick({
            slidesToShow: 2.1,
            dots: false,
            arrows: false,
            infinite: false,
            rtl: $("body").hasClass("rtl") ? true : false,
        });
        // Share Button Expand Icons
        $("#mediaShareButton").addClass("expanded");
    }
    $(".movies-images-slider").slick({
        slidesToShow: 4,
        dots: false,
        arrows: true,
        centerMode: true,
        infinite: true,
        prevArrow: $('.custom-arrows .slick-prev'),
        nextArrow: $('.custom-arrows .slick-next'),
        centerPadding: '60px',
        rtl: $("body").hasClass("rtl") ? true : false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    centerMode: true,
                    centerPadding: '100px',
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 586,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    centerMode: true,
                    centerPadding: '30px',
                    slidesToShow: 1,
                }
            }
        ]
    });

    $("#homepageMediaSlider, #detailsMediaSlider").slick({
        slidesToShow: 3.5,
        dots: false,
        arrows: true,
        infinite: false,
        prevArrow: ".arrows-container .previous",
        nextArrow: ".arrows-container .next",
        rtl: $("body").hasClass("rtl") ? true : false,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 2.3,

                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1.6,

                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1.3,

                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.2,

                }
            },
            {
                breakpoint: 586,
                settings: {
                    slidesToShow: 1.3,

                }
            }

        ]
    });

    if(document.querySelector("#mediaDetailPageImagesSlider")){
        const ps = new PerfectScrollbar("#mediaDetailPageImagesSlider", {
            speed: 3,
            wheelPropagation: true,
            swipeEasing: true,
        });
        if($(window).width() < 768){
            ps.destroy();
        }
        $("#mediaDetailPageImagesSlider .image-item").on("click", function(event){
            event.preventDefault();
            let currentImageItem = $(this);
            $("#mediaDetailPageImagesSlider .image-item").removeClass("selected");
            $("#selectedImage").addClass("fade-out")
            currentImageItem.addClass("selected");

            setTimeout(function() {
                $("#selectedImage").attr("src", currentImageItem.find("img").attr("src"));
                $("#selectedImage").removeClass("fade-out");
                $("#selectedImage").addClass("fade-in");
                setTimeout(function() {
                  $("#selectedImage").remove("fade-in");
                }, 200); // set the time for the fade-in animation to complete
              }, 200);
        });
    }

    $("#movieGallerySlider").slick({
        slidesToShow: 1,
        dots: false,
        arrows: true,
        infinite: true,
        centerMode: true,
        centerPadding: 'calc((100vw - 1080px) / 2)',
        prevArrow: ".movie-details .previous-arrow",
        nextArrow: ".movie-details .next-arrow",
        rtl: $("body").hasClass("rtl") ? true : false,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    centerPadding: 'calc((100vw - 980px)    / 2 )',
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    centerPadding: 'calc((100vw - 780px)    / 2 )',
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    centerPadding: 'calc((100vw - 620px)    / 2 )'
                }
            },
            {
                breakpoint: 900,
                settings: {
                    centerPadding: 'calc((100vw - 500px)    / 2 )'
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.1,
                    infinite: false,
                    arrows: false,
                }
            }
        ]
    });

    $(".openImagePreview").on("click", function(event){
        event.preventDefault();
        var imgSrc = $(this).attr("src");
        $(".image-preview-popup").find("img").attr("src", imgSrc)
        $("html").css("overflow-y", "hidden");
        $(".image-preview-popup").fadeIn("slow").css("display", "flex");
    });
    $(".image-preview-popup .closeBtn").on("click", function (event) {
        event.preventDefault();
        $(".image-preview-popup").fadeOut("slow");
        $("html").css("overflow-y", "auto");
        $(".image-preview-popup img").attr("src", " ");
    });
    AOS.init({
        duration: 1500,
        easing: 'slide'
    });

    $(document).on("click", ".plus-button", function(e) {
        e.preventDefault();
        var newRecord = $(this).closest(".record").clone();
        newRecord.find("input").val("");
        $(this).closest(".record").after(newRecord);
    });

    $(document).on("click", ".minus-button", function(e) {
        e.preventDefault();
        if ($(this).closest(".record").siblings(".record").length > 0) {
            $(this).closest(".record").remove();
        }
    });

    // Rebate forms

    var ksi_trade_license_index = 0;
    $(".rebate-form-page .form-container form .action .add button").click(function (e) {
        e.preventDefault();
        ksi_trade_license_index++;
        let content_append = $(this).parent().parent().parent().clone();
        content_append = content_append.find("input").attr("value", "").end().show();
        var fileContainer = content_append.find(".fileContainer");
        if (fileContainer.length) {
            var icon_download = "";
            var icon_delete = "";
            var icon_upload = "";
            var input_file_name = "";
            var isRequired = 0;
            var file_accept = "";
            var isMultiple = 0;
            var special = "";
            var max_size = 0;
            if (fileContainer.data("icon-download") && (fileContainer.data("icon-download") != "")) {
                icon_download = fileContainer.data("icon-download");
            }
            if (fileContainer.data("icon-delete") && (fileContainer.data("icon-delete") != "")) {
                icon_delete = fileContainer.data("icon-delete");
            }
            if (fileContainer.data("icon-upload") && (fileContainer.data("icon-upload") != "")) {
                icon_upload = fileContainer.data("icon-upload");
            }
            if (fileContainer.data("name") && (fileContainer.data("name") != "")) {
                input_file_name = fileContainer.data("name");
            }
            if (fileContainer.data("required") && (fileContainer.data("required") != "")) {
                isRequired = fileContainer.data("required");
            }
            if (fileContainer.data("accept") && (fileContainer.data("accept") != "")) {
                file_accept = fileContainer.data("accept");
            }
            if (fileContainer.data("multiple") && (fileContainer.data("multiple") != "")) {
                isMultiple = fileContainer.data("multiple");
            }
            special = fileContainer.data("special");
            if (special === undefined) {
                special = "";
            } else {
                special = ksi_trade_license_index;
            }
            if (fileContainer.data("max-size") && (fileContainer.data("max-size") != "")) {
                max_size = fileContainer.data("max-size");
            }
            fileContainer.attr("data-id", "0");
            fileContainer.attr("data-mediaid", "");
            fileContainer.attr("data-value", "");
            fileContainer.attr("data-href", "");

            var returnedHTML = '';
            returnedHTML += '\
            <label class="file cursor" for="' + input_file_name;
            if (special !== "") {
                returnedHTML += "_" + special;
            }
            returnedHTML += '">';
            returnedHTML += '\
                <img src="' + icon_upload + '" alt="Upload" />\
                <span class="upload">Upload / تحميل</span>\
            </label>\
            <input type="file"';
            // if (isMultiple == 1) {
            //     returnedHTML += ' multiple';
            // }
            returnedHTML += ' id="' + input_file_name;
            if (special !== "") {
                returnedHTML += "_" + special;
            }
            returnedHTML += '" name="' + input_file_name;
            if ((isMultiple == 1) || (special !== "")) {
                returnedHTML += "[]";
            }
            returnedHTML += '" class="fileUpload" accept="' + file_accept + '" data-max-size="' + max_size + '"';
            if (isRequired) {
                returnedHTML += " required";
            }
            returnedHTML += " />";

            returnedHTML += '\
                <label id="' + input_file_name;
            if (special !== "") {
                returnedHTML += "_" + special;
            }
            returnedHTML += '-error" class="error" for="' + input_file_name;
            if (special !== "") {
                returnedHTML += "_" + special;
            }
            returnedHTML += '"></label>';
            returnedHTML += '\
            <div class="loading"><span class="spinner"></span></div>';

            content_append = content_append.find(".fileContainer").html(returnedHTML).end().show();
        }
        $(this).parent().parent().parent().parent().find(".append-container").append(content_append);
    });
    $(".rebate-form-page").on("click", ".rebate-form .remove button", function(e) {
        e.preventDefault();
        $(this).parent().parent().parent().remove();
    });

    function check_if_show_production_format_subcategory(firstLoad = false) {
        if ($('input[name="production_format_subcategory"]').length > 0) {
            if (firstLoad == false) {
                $('input[name="production_format_subcategory"]').prop("checked", false);
            }
            if ($('input[name="production_format"]:checked').val() === "Television Programme or Series") {
                if ($(window).width() < 768) {
                    $(".production_format_subcategory_section").hide();
                    $(".production_format_subcategory_section.tv_series").show();
                } else {
                    $(".production_format_subcategory_section").show();
                    $(".production_format_subcategory_section.tv_series").css({"visibility": "visible"});
                    $(".production_format_subcategory_section.feature_film").css({"visibility": "hidden"});
                }
            } else if ($('input[name="production_format"]:checked').val() === "Feature Film") {
                if ($(window).width() < 768) {
                    $(".production_format_subcategory_section").hide();
                    $(".production_format_subcategory_section.feature_film").show();
                } else {
                    $(".production_format_subcategory_section").show();
                    $(".production_format_subcategory_section.tv_series").css({"visibility": "hidden"});
                    $(".production_format_subcategory_section.feature_film").css({"visibility": "visible"});
                }
            } else {
                $(".production_format_subcategory_section").hide();
            }
        }
    }
    $(document).on("click", 'input[name="production_format"]', function(e) {
        check_if_show_production_format_subcategory();
    });
    check_if_show_production_format_subcategory(true);

    function check_if_same_as_applicant_company() {
        if ($('input[name="same_as_applicant_company"]:checked').length > 0) {
            if ($('input[name="same_as_applicant_company"]:checked').val() === "Yes") {
                $("#section_to_show_if_same_as_applicant_company #trade_name_of_production_company").attr("readonly", true).val($("#trade_name_of_applicant_company").val());
                $("#section_to_show_if_same_as_applicant_company #production_company_contact_name").attr("readonly", true).val($("#applicant_company_contact_name").val());
                $("#section_to_show_if_same_as_applicant_company #production_company_contact_position").attr("readonly", true).val($("#applicant_company_contact_position").val());
                $("#section_to_show_if_same_as_applicant_company #production_company_contact_email_address").attr("readonly", true).val($("#applicant_company_contact_email_address").val());
                $("#section_to_show_if_same_as_applicant_company #production_company_contact_phone_number").attr("readonly", true).val($("#applicant_company_contact_phone_number").val());
                $("#section_to_show_if_same_as_applicant_company #production_ultimate_holding_company").attr("readonly", true).val($("#applicant_ultimate_holding_company").val());
            } else {
                $("#section_to_show_if_same_as_applicant_company #trade_name_of_production_company").attr("readonly", false).val("");
                $("#section_to_show_if_same_as_applicant_company #production_company_contact_name").attr("readonly", false).val("");
                $("#section_to_show_if_same_as_applicant_company #production_company_contact_position").attr("readonly", false).val("");
                $("#section_to_show_if_same_as_applicant_company #production_company_contact_email_address").attr("readonly", false).val("");
                $("#section_to_show_if_same_as_applicant_company #production_company_contact_phone_number").attr("readonly", false).val("");
                $("#section_to_show_if_same_as_applicant_company #production_ultimate_holding_company").attr("readonly", false).val("");
            }
        }
    }
    $(document).on("click", 'input[name="same_as_applicant_company"]', function(e) {
        check_if_same_as_applicant_company();
    });

    $.validator.addMethod("max_words", function(value, element, params) {
        var words = value.trim().split(/\s+/);
        return words.length <= params;
    }, "Maximum {0} words allowed.");

    var form = $("#rebateForm");
    form.validate({
        rules: {
            applicant_contact_name: {
                required: true,
                maxlength: 255,
            },
            final_production_title: {
                required: true,
                maxlength: 255,
            },
            logline50: {
                required: true,
                max_words: 50,
            },
            synopsis_outline_of_episodes: {
                required: true,
                max_words: 200,
            },
        },
        invalidHandler: function(event, validator) {
            var firstInvalidElement = validator.errorList[0].element;
            window.scrollTo({top: $(firstInvalidElement).offset().top - 100, behavior: "smooth"});
        },
    });
    // $(".rebate-form-page .form-container .numbering ul li label").click(function (e) {
    //     e.preventDefault();
    //     const data_active = $(this).data("active");
    //     $(".rebate-form-page .form-container .numbering ul li label").removeClass("active");
    //     $(".rebate-form-page .form-container .numbering ul li label[data-active=" + data_active + "]").addClass("active");
    //     $(".rebate-form-page .form-container form .inner-content").removeClass("active");
    //     $(".rebate-form-page .form-container form .inner-content[data-active=" + data_active + "]").addClass("active");
    //     $(".rebate-form-page .form-container form .submit-container .form-submit-button").removeClass("active");
    //     $(".rebate-form-page .form-container form .submit-container .form-submit-button[data-active=" + data_active + "]").addClass("active");
    //     $(".rebate-form-page .form-container form .submit-container .form-previous-button").removeClass("active");
    //     if (data_active !== "active-1") {
    //         $(".rebate-form-page .form-container form .submit-container .form-previous-button[data-active=" + data_active + "]").addClass("active");
    //     }
    // });
    $(".rebate-form-page .form-container form .submit-container a.form-previous-button").click(function (e) {
        $("html, body").animate({ scrollTop: "0" }, 100, "swing");
        const data_previous_active = $(this).data("previous-active");
        // var currentStep = helper.getStepNumber(data_previous_active);
        // console.log("On previous click => currentStep", currentStep);

        $(".rebate-form-page .form-container .numbering ul li label").removeClass("active");
        $(".rebate-form-page .form-container .numbering ul li label[data-active=" + data_previous_active + "]").addClass("active");
        $(".rebate-form-page .form-container form .inner-content").removeClass("active");
        $(".rebate-form-page .form-container form .inner-content[data-active=" + data_previous_active + "]").addClass("active");
        $(".rebate-form-page .form-container form .submit-container .form-submit-button").removeClass("active");
        $(".rebate-form-page .form-container form .submit-container .form-submit-button[data-active=" + data_previous_active + "]").addClass("active");
        $(".rebate-form-page .form-container form .submit-container .form-previous-button").removeClass("active");
        if (data_previous_active !== "active-1") {
            $(".rebate-form-page .form-container form .submit-container .form-previous-button[data-active=" + data_previous_active + "]").addClass("active");
        }

        $("#saveBtn").css("display", "inline-flex");
        $("#copyBtn").css("display", "none");
        $("#responseSuccessMessage").css("display", "none");
        $("#responseErrorMessage").css("display", "none");
        $("#responseCaptchaErrorMessage").css("display", "none");
        $(".pleaseWaitMoment").fadeOut();
    });
    $(".rebate-form-page .form-container form .submit-container a.form-submit-button").click(function (e) {
        e.preventDefault();
        var btn = $(this);

        var isValid = form.valid();
        if (!form.valid()) {
            // console.log("Click on a.form-submit-button form not valid");
            return false;
        } else {
            // console.log("Click on a.form-submit-button form valid");
            // var currentStep = helper.getStepNumber(btn.data("active"));
            // console.log("On next click => currentStep", currentStep);

            $("#saveBtn").css("display", "inline-flex");
            $("#copyBtn").css("display", "none");
            $("#responseSuccessMessage").css("display", "none");
            $("#responseErrorMessage").css("display", "none");
            $("#responseCaptchaErrorMessage").css("display", "none");
            $(".pleaseWaitMoment").fadeOut();
            if ($('label[id$="-error"]').length > 0) {
                $('label[id$="-error"]').html("");
            }
            if ($('label[id$="_ajax-error"]').length > 0) {
                $('label[id$="_ajax-error"]').html("");
            }
            var VAR_CAPTCHA_ACTIVATE = $("#VAR_CAPTCHA_ACTIVATE_ajax").val();
            if (VAR_CAPTCHA_ACTIVATE == 1) {
                var VAR_CAPTCHA_SITE_KEY = $("#VAR_CAPTCHA_SITE_KEY_ajax").val();
                btn.css("pointer-events", "none");
                btn.find(".spinner").css("display", "block");
                $(".pleaseWaitMoment.initial").fadeIn();
                try {
                    grecaptcha.execute(VAR_CAPTCHA_SITE_KEY, {
                        action: "form/submit"
                    }).then(function(tokenCaptcha) {
                        $("#g-recaptcha-response_ajax").val(tokenCaptcha);
                        if (tokenCaptcha == "") {
                            btn.css("pointer-events", "auto");
                            btn.find(".spinner").css("display", "none");
                            $(".pleaseWaitMoment").fadeOut();
                            $("#responseCaptchaErrorMessage").css("display", "inline");
                            return false;
                        } else {
                            helper.submitAjaxForm(form, btn);
                        }
                    }, function(reason) {
                        btn.css("pointer-events", "auto");
                        btn.find(".spinner").css("display", "none");
                        $(".pleaseWaitMoment").fadeOut();
                        $("#responseCaptchaErrorMessage").css("display", "inline");
                        return false;
                    });
                } catch (error) {
                    console.log(error);
                    helper.submitAjaxForm(form, btn);
                }
            } else {
                btn.css("pointer-events", "none");
                btn.find(".spinner").css("display", "block");
                $(".pleaseWaitMoment.initial").fadeIn();
                helper.submitAjaxForm(form, btn);
            }
        }
    });

    $(document).on("focus", ".formDate", function(e) {
        e.preventDefault();
        // $(this).attr("type", "date");
        // $(this).focus();
        $(this).datepicker({
            dateFormat: "yy-mm-dd",
        });
    });
    // $(document).on("blur", ".formDate", function(e) {
    //     e.preventDefault();
    //     $(this).attr("type", "text");
    // });

    $(document).on("focus", ".formTime", function(e) {
        e.preventDefault();
        // $(this).attr("type", "time");
        // $(this).focus();
        $(this).timepicker({
            "timeFormat": "HH:mm:ss"
        });
    });
    // $(document).on("blur", ".formTime", function(e) {
    //     e.preventDefault();
    //     $(this).attr("type", "text");
    // });

    if ($("#rebateForm").length > 0) {
        if ($("#rebateForm").attr("name") != "") {
            var lsRebateFormUUID = $("#rebateForm").attr("name") + "-uuid";
            var rebateFormUuid = localStorage.getItem(lsRebateFormUUID);
            if (rebateFormUuid) {
                if ($("#uuid").length && ($("#uuid").val() != "")) {
                    localStorage.setItem(lsRebateFormUUID, $("#uuid").val());
                } else if ($("#uuid").length == 0) {
                    localStorage.setItem(lsRebateFormUUID, helper.generateUniqueFormUuid());
                }
            } else if ($("#uuid").length && ($("#uuid").val() != "")) {
                localStorage.setItem(lsRebateFormUUID, $("#uuid").val());
            } else if ($("#uuid").length == 0) {
                localStorage.setItem(lsRebateFormUUID, helper.generateUniqueFormUuid());
            }
            // console.log("rebateFormUuid", localStorage.getItem(lsRebateFormUUID));

            var lsRebateFormStep = $("#rebateForm").attr("name") + "-step";
            var rebateFormStep = localStorage.getItem(lsRebateFormStep);
            if (rebateFormStep) {
                if ($("#step").length && ($("#step").val() != "")) {
                    localStorage.setItem(lsRebateFormStep, $("#step").val());
                } else if ($("#step").length == 0) {
                    localStorage.setItem(lsRebateFormStep, 1);
                }
            } else if ($("#step").length && ($("#step").val() != "")) {
                localStorage.setItem(lsRebateFormStep, $("#step").val());
            } else if ($("#step").length == 0) {
                localStorage.setItem(lsRebateFormStep, 1);
            }
            // console.log("rebateFormStep", localStorage.getItem(lsRebateFormStep));

            $('input[type=text], input[type=number], input[type=email], input[type=date], input[type=url], input[type=checkbox], input[type=radio], input[type=file], select').on("input", function() {
                if ($(this).val().trim() !== "") {
                    $("#responseSuccessMessage").css("display", "none");
                    $("#responseErrorMessage").css("display", "none");
                    $("#saveBtn").css("display", "inline-flex");
                    $("#copyBtn").css("display", "none");
                    $(".pleaseWaitMoment").fadeOut();
                }
            });
        }
    }

    $(document).on("change", ".fileUpload", function(e) {
        $("#responseSuccessMessage").css("display", "none");
        $("#responseErrorMessage").css("display", "none");
        $(".pleaseWaitMoment").fadeOut();
        const thisFile = $(this);
        const fileContainerExist = thisFile.parent().parent().find(".fileContainer");
        // console.log("Found", fileContainerExist);
        const fileContainer = thisFile.parent();
        if (fileContainer.length) {
            // Get data attributes
            var allowedExtensions = fileContainer.data("accept").split(",");
            // console.log("allowedExtensions", allowedExtensions);
            var maxSize = parseInt(fileContainer.data("max-size"));
            // console.log("maxSize", maxSize);

            var fileInput = thisFile[0];
            var files = fileInput.files;
            var fileName = "";
            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    var alertMsg = trans("Please choose a valid file.");
                    if ($("#" + fileInput.id).length > 0) {
                        $("#" + fileInput.id).removeClass("error").addClass("valid");
                    }
                    if ($("#" + fileInput.id + "-error").length > 0) {
                        $("#" + fileInput.id + "-error").html("").hide();
                    }

                    // Check if a file is selected
                    if (!file) {
                        alertMsg = trans("Please choose a valid file.");
                        if ($("#" + fileInput.id).length > 0) {
                            $("#" + fileInput.id).removeClass("valid").addClass("error");
                        }
                        if ($("#" + fileInput.id + "-error").length > 0) {
                            $("#" + fileInput.id + "-error").html(alertMsg).show();
                        }
                        return false;
                    }

                    // Check file extension
                    var nameFile = file.name.toLowerCase();
                    var fileExtension = nameFile.substring(nameFile.lastIndexOf("."));
                    if (allowedExtensions.indexOf(fileExtension) === -1) {
                        // alertMsg = trans("Invalid file extension for") + " " + fileInput.id + ". " + trans("Please choose a valid file.");
                        alertMsg = trans("Invalid file extension. Please choose a valid file.");
                        if ($("#" + fileInput.id).length > 0) {
                            $("#" + fileInput.id).removeClass("valid").addClass("error");
                        }
                        if ($("#" + fileInput.id + "-error").length > 0) {
                            $("#" + fileInput.id + "-error").html(alertMsg).show();
                        }
                        return false;
                    }

                    // Check file size
                    // console.log("file.size", file.size);
                    if (file.size > maxSize) {
                        // alertMsg = trans("File size for") + " " + fileInput.id + trans(" exceeds the limit. Please choose a smaller file.");
                        alertMsg = trans("File size exceeds the limit. Please choose a smaller file.");
                        if ($("#" + fileInput.id).length > 0) {
                            $("#" + fileInput.id).removeClass("valid").addClass("error");
                        }
                        if ($("#" + fileInput.id + "-error").length > 0) {
                            $("#" + fileInput.id + "-error").html(alertMsg).show();
                        }
                        return false;
                    }
                    if (i > 0) {
                        fileName += ", ";
                    }
                    fileName += file.name;
                }
            }
            const span = thisFile.parent().find("label.cursor span");
            // const fileName = thisFile.val().split("\\").pop();
            if ($.trim(fileName) == "") {
                span.text("Upload / تحميل");
            } else {
                span.text(fileName);
            }
            if (fileContainerExist.length) {
                var VAR_CAPTCHA_ACTIVATE = $("#VAR_CAPTCHA_ACTIVATE_ajax").val();
                if (VAR_CAPTCHA_ACTIVATE == 1) {
                    var VAR_CAPTCHA_SITE_KEY = $("#VAR_CAPTCHA_SITE_KEY_ajax").val();
                    try {
                        grecaptcha.execute(VAR_CAPTCHA_SITE_KEY, {
                            action: "form/uploadFile"
                        }).then(function(tokenCaptcha) {
                            $("#g-recaptcha-response_ajax").val(tokenCaptcha);
                            if (tokenCaptcha == "") {
                                alert(trans("main.verify_that_not_robot"));
                                return false;
                            } else {
                                helper.selectFuncForFiles(thisFile, "upload", fileContainer);
                            }
                        }, function(reason) {
                            alert(trans("main.verify_that_not_robot"));
                            return false;
                        });
                    } catch (error) {
                        console.log(error);
                        helper.selectFuncForFiles(thisFile, "upload", fileContainer);
                    }
                } else {
                    helper.selectFuncForFiles(thisFile, "upload", fileContainer);
                }
            }
        } else {
            console.log("Not found", fileContainer);
            return false;
        }
    });

    $(document).on("click", ".deleteFile", function(e) {
        e.preventDefault();
        $("#responseSuccessMessage").css("display", "none");
        $("#responseErrorMessage").css("display", "none");
        $(".pleaseWaitMoment").fadeOut();
        const thisFile = $(this);
        const fileContainer = thisFile.parent().parent();
        if (fileContainer.length) {
            var VAR_CAPTCHA_ACTIVATE = $("#VAR_CAPTCHA_ACTIVATE_ajax").val();
            if (VAR_CAPTCHA_ACTIVATE == 1) {
                var VAR_CAPTCHA_SITE_KEY = $("#VAR_CAPTCHA_SITE_KEY_ajax").val();
                try {
                    grecaptcha.execute(VAR_CAPTCHA_SITE_KEY, {
                        action: "form/deleteFile"
                    }).then(function(tokenCaptcha) {
                        $("#g-recaptcha-response_ajax").val(tokenCaptcha);
                        if (tokenCaptcha == "") {
                            alert(trans("main.verify_that_not_robot"));
                            return false;
                        } else {
                            helper.selectFuncForFiles(thisFile, "delete", fileContainer);
                        }
                    }, function(reason) {
                        alert(trans("main.verify_that_not_robot"));
                        return false;
                    });
                } catch (error) {
                    console.log(error);
                    helper.selectFuncForFiles(thisFile, "delete", fileContainer);
                }
            } else {
                helper.selectFuncForFiles(thisFile, "delete", fileContainer);
            }
        }
    });

    if ($("#saveBtn").length > 0) {
        $(document).on("click", "#saveBtn", function(e) {
            e.preventDefault();
            $("#responseSuccessMessage").css("display", "none");
            $("#responseErrorMessage").css("display", "none");
            $(".pleaseWaitMoment").fadeOut();
            var btn = $(this);
            var VAR_CAPTCHA_ACTIVATE = $("#VAR_CAPTCHA_ACTIVATE_ajax").val();
            if (VAR_CAPTCHA_ACTIVATE == 1) {
                var VAR_CAPTCHA_SITE_KEY = $("#VAR_CAPTCHA_SITE_KEY_ajax").val();
                btn.css("pointer-events", "none");
                btn.find(".spinner").css("display", "block");
                try {
                    grecaptcha.execute(VAR_CAPTCHA_SITE_KEY, {
                        action: "form/save"
                    }).then(function(tokenCaptcha) {
                        $("#g-recaptcha-response_ajax").val(tokenCaptcha);
                        if (tokenCaptcha == "") {
                            btn.css("pointer-events", "auto");
                            btn.find(".spinner").css("display", "none");
                            return false;
                        } else {
                            helper.saveAjaxForm(form, btn);
                        }
                    }, function(reason) {
                        btn.css("pointer-events", "auto");
                        btn.find(".spinner").css("display", "none");
                        return false;
                    });
                } catch (error) {
                    console.log(error);
                    helper.saveAjaxForm(form, btn);
                }
            } else {
                btn.css("pointer-events", "none");
                btn.find(".spinner").css("display", "block");
                helper.saveAjaxForm(form, btn);
            }
        });
    }

    if ($("#copyBtn").length > 0) {
        $(document).on("click", "#copyBtn", function(e) {
            e.preventDefault();
            $("#responseSuccessMessage").css("display", "none");
            $("#responseErrorMessage").css("display", "none");
            $(".pleaseWaitMoment").fadeOut();
            const btn = $(this);
            btn.css("pointer-events", "none");
            btn.find(".spinner").css("display", "block");
            if ($("#uuid").length && ($("#uuid").val() != "")) {
                var path = window.location.pathname;
                var segments = path.split("/").filter(function(segment) {
                    return segment !== "";
                });
                var lastSegment = segments.pop();
                var tempTextarea = $("<textarea>");
                if (!helper.isUUID(lastSegment)) {
                    tempTextarea.val(helper.getBaseUrl() + "/" + $("#uuid").val());
                } else {
                    tempTextarea.val(helper.getBaseUrl());
                }
                $("body").append(tempTextarea);
                tempTextarea.select();
                document.execCommand("copy");
                tempTextarea.remove();
            }
            setTimeout(() => {
                btn.css("pointer-events", "auto");
                btn.find(".spinner").css("display", "none");
                $(".pleaseWaitMoment.copiedToClipboard").fadeIn();
                $("#saveBtn").css("display", "inline-flex");
                $("#copyBtn").css("display", "none");
            }, 500);
            setTimeout(() => {
                $(".pleaseWaitMoment").fadeOut();
            }, 3000);
        });
    }

    if ($(".previewRebateForm").length > 0) {
        var rebateModal = $("#rebateModal");
        var rebateModalBody = $("#rebateModalBody");

        $(document).on("click", ".previewRebateForm", function(e) {
            e.preventDefault();
            var url = $(this).data("url");
            // console.log(url);
            rebateModal.show();

            $.ajax({
                url: url,
                method: "GET",
                success: function(data) {
                    rebateModalBody.html(data);
                },
                error: function() {
                    rebateModalBody.html("<p>Failed to load content. Please try again later.</p>");
                }
            });
        });

        $(".rebateClose").click(function() {
            rebateModal.hide();
            rebateModalBody.html("");
        });

        $(window).click(function(event) {
            if ($(event.target).is(rebateModal)) {
                rebateModal.hide();
                rebateModalBody.html("");
            }
        });

        function check_if_show_preview_production_format_subcategory(firstLoad = false) {
            if ($('input[name="preview_production_format_subcategory"]').length > 0) {
                if (firstLoad == false) {
                    $('input[name="preview_production_format_subcategory"]').prop("checked", false);
                }
                if ($('input[name="preview_production_format"]:checked').val() === "Television Programme or Series") {
                    if ($(window).width() < 768) {
                        $(".preview_production_format_subcategory_section").hide();
                        $(".preview_production_format_subcategory_section.tv_series").show();
                    } else {
                        $(".preview_production_format_subcategory_section").show();
                        $(".preview_production_format_subcategory_section.tv_series").css({"visibility": "visible"});
                        $(".preview_production_format_subcategory_section.feature_film").css({"visibility": "hidden"});
                    }
                } else if ($('input[name="preview_production_format"]:checked').val() === "Feature Film") {
                    if ($(window).width() < 768) {
                        $(".preview_production_format_subcategory_section").hide();
                        $(".preview_production_format_subcategory_section.feature_film").show();
                    } else {
                        $(".preview_production_format_subcategory_section").show();
                        $(".preview_production_format_subcategory_section.tv_series").css({"visibility": "hidden"});
                        $(".preview_production_format_subcategory_section.feature_film").css({"visibility": "visible"});
                    }
                } else {
                    $(".preview_production_format_subcategory_section").hide();
                }
            }
        }
        $(document).on("click", 'input[name="preview_production_format"]', function(e) {
            check_if_show_preview_production_format_subcategory();
        });
        check_if_show_preview_production_format_subcategory(true);

        function check_if_preview_same_as_applicant_company() {
            if ($('input[name="preview_same_as_applicant_company"]:checked').length > 0) {
                if ($('input[name="preview_same_as_applicant_company"]:checked').val() === "Yes") {
                    $("#section_to_show_if_preview_same_as_applicant_company #trade_name_of_production_company").attr("readonly", true).val($("#trade_name_of_applicant_company").val());
                    $("#section_to_show_if_preview_same_as_applicant_company #production_company_contact_name").attr("readonly", true).val($("#applicant_company_contact_name").val());
                    $("#section_to_show_if_preview_same_as_applicant_company #production_company_contact_position").attr("readonly", true).val($("#applicant_company_contact_position").val());
                    $("#section_to_show_if_preview_same_as_applicant_company #production_company_contact_email_address").attr("readonly", true).val($("#applicant_company_contact_email_address").val());
                    $("#section_to_show_if_preview_same_as_applicant_company #production_company_contact_phone_number").attr("readonly", true).val($("#applicant_company_contact_phone_number").val());
                    $("#section_to_show_if_preview_same_as_applicant_company #production_ultimate_holding_company").attr("readonly", true).val($("#applicant_ultimate_holding_company").val());
                } else {
                    $("#section_to_show_if_preview_same_as_applicant_company #trade_name_of_production_company").attr("readonly", false).val("");
                    $("#section_to_show_if_preview_same_as_applicant_company #production_company_contact_name").attr("readonly", false).val("");
                    $("#section_to_show_if_preview_same_as_applicant_company #production_company_contact_position").attr("readonly", false).val("");
                    $("#section_to_show_if_preview_same_as_applicant_company #production_company_contact_email_address").attr("readonly", false).val("");
                    $("#section_to_show_if_preview_same_as_applicant_company #production_company_contact_phone_number").attr("readonly", false).val("");
                    $("#section_to_show_if_preview_same_as_applicant_company #production_ultimate_holding_company").attr("readonly", false).val("");
                }
            }
        }
        $(document).on("click", 'input[name="preview_same_as_applicant_company"]', function(e) {
            check_if_preview_same_as_applicant_company();
        });

        $(".rebate-form-page .form-container .numbering.preview ul li label").click(function (e) {
            e.preventDefault();
            const data_active = $(this).data("active");
            $(".rebate-form-page .form-container .numbering.preview ul li label").removeClass("active");
            $(".rebate-form-page .form-container .numbering.preview ul li label[data-active=" + data_active + "]").addClass("active");
            $(".rebate-form-page .form-container form .inner-content-preview").removeClass("active");
            $(".rebate-form-page .form-container form .inner-content-preview[data-active=" + data_active + "]").addClass("active");
            $(".rebate-form-page .form-container form .submit-container .form-submit-button-preview").removeClass("active");
            $(".rebate-form-page .form-container form .submit-container .form-submit-button-preview[data-active=" + data_active + "]").addClass("active");
            $(".rebate-form-page .form-container form .submit-container .form-previous-button-preview").removeClass("active");
            if (data_active !== "active-1") {
                $(".rebate-form-page .form-container form .submit-container .form-previous-button-preview[data-active=" + data_active + "]").addClass("active");
            }
        });
        $(".rebate-form-page .form-container form .submit-container a.form-previous-button-preview").click(function (e) {
            $("html, body").animate({ scrollTop: "0" }, 100, "swing");
            const data_previous_active = $(this).data("previous-active");
            $(".rebate-form-page .form-container .numbering.preview ul li label").removeClass("active");
            $(".rebate-form-page .form-container .numbering.preview ul li label[data-active=" + data_previous_active + "]").addClass("active");
            $(".rebate-form-page .form-container form .inner-content-preview").removeClass("active");
            $(".rebate-form-page .form-container form .inner-content-preview[data-active=" + data_previous_active + "]").addClass("active");
            $(".rebate-form-page .form-container form .submit-container .form-submit-button-preview").removeClass("active");
            $(".rebate-form-page .form-container form .submit-container .form-submit-button-preview[data-active=" + data_previous_active + "]").addClass("active");
            $(".rebate-form-page .form-container form .submit-container .form-previous-button-preview").removeClass("active");
            if (data_previous_active !== "active-1") {
                $(".rebate-form-page .form-container form .submit-container .form-previous-button-preview[data-active=" + data_previous_active + "]").addClass("active");
            }

            $("#rebateModalBody").animate({ scrollTop: 0 }, "slow");
        });
        $(".rebate-form-page .form-container form .submit-container a.form-submit-button-preview").click(function (e) {
            e.preventDefault();
            var previewForm = $("#rebateFormPreview");
            var btn = $(this);
            helper.previewSubmitAjaxForm(previewForm, btn);
        });
    }

    $(document).on("click", ".hideTickFixed", function(e) {
        $(".tickFixed").fadeOut(500, function() {
            $(this).remove();
        });
    });
});
